module.exports = __webpack_public_path__ + "img/ods-logo-rueda.be573707.png";